var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0 reversed", attrs: { fluid: "" } },
    [
      _c(
        "v-window",
        {
          model: {
            value: _vm.windowIndex,
            callback: function($$v) {
              _vm.windowIndex = $$v
            },
            expression: "windowIndex"
          }
        },
        [
          _c(
            "v-window-item",
            { attrs: { value: 1 } },
            [
              _c(
                "v-container",
                { staticClass: "DashboardBox", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "borderbox d-flex justify-space-between elevation-1 pa-3 align-center"
                          },
                          [
                            _c("div", { staticClass: "d-flex align-center" }, [
                              _c("img", {
                                staticClass: "mr-2",
                                attrs: {
                                  src: require("@/assets/IconCM.svg"),
                                  width: "35px",
                                  height: "35px"
                                }
                              }),
                              _c("p", { staticClass: "textpCustom title" }, [
                                _c("b", [_vm._v("Administración de clientes")])
                              ])
                            ])
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-title",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "prepend-inner-icon":
                                                "mdi-magnify",
                                              label: "Buscar",
                                              "single-line": "",
                                              "hide-details": ""
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.getCustomers()
                                              }
                                            },
                                            model: {
                                              value: _vm.search,
                                              callback: function($$v) {
                                                _vm.search = $$v
                                              },
                                              expression: "search"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "white--text mr-2 mt-5",
                                              attrs: {
                                                color: "green",
                                                disabled: _vm.loadingCustomers
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getCustomers()
                                                }
                                              }
                                            },
                                            [_vm._v(" Buscar ")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.customers,
                                  options: _vm.customerOptions,
                                  "items-per-page": _vm.itemsPerPage[0],
                                  "items-per-page-options": _vm.itemsPerPage,
                                  "footer-props": {
                                    itemsPerPageOptions: _vm.itemsPerPage,
                                    itemsPerPageText:
                                      "Cantidad de clientes por página",
                                    prevIcon: "",
                                    nextIcon: "",
                                    pageText: ""
                                  },
                                  loading: _vm.loadingCustomers,
                                  "loading-text": _vm.loadingText,
                                  "no-data-text": _vm.noDataText
                                },
                                on: {
                                  "update:options": function($event) {
                                    _vm.customerOptions = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "no-data",
                                    fn: function() {
                                      return [
                                        _vm._v(" No hay datos disponibles ")
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "no-results",
                                    fn: function() {
                                      return [
                                        _vm._v(" No se encontraron resultados ")
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "item.action",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-2",
                                            attrs: { small: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.editItem(item)
                                              }
                                            }
                                          },
                                          [_vm._v("mdi-pencil")]
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { small: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.fireWarning(item)
                                              }
                                            }
                                          },
                                          [_vm._v("mdi-delete")]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "item.adminUser",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              color: item.adminUser
                                                ? "green"
                                                : "gray",
                                              dark: "",
                                              small: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.adminUser
                                                  ? "Administrador activo"
                                                  : "Sin administrador"
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "item.name",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "ml-10 text-center" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.name) + " "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "header.name",
                                    fn: function(ref) {
                                      var header = ref.header
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "ml-10 text-center" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(header.text) + " "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "item",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "tr",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.changeCustomer(item)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-right" },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-right" },
                                              [_vm._v(_vm._s(item.rif))]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-right" },
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      color: item.adminUser
                                                        ? "green"
                                                        : "gray",
                                                      dark: "",
                                                      small: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.adminUser
                                                            ? "Administrador activo"
                                                            : "Sin administrador"
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "blue-grey lighten-4 ma-0 py-2" },
                            [
                              _c("v-pagination", {
                                attrs: {
                                  length: _vm.pages,
                                  "total-visible": 7
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.getCustomers()
                                  }
                                },
                                model: {
                                  value: _vm.page,
                                  callback: function($$v) {
                                    _vm.page = $$v
                                  },
                                  expression: "page"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-window-item",
            { key: _vm.customerKey, attrs: { value: 2 } },
            [
              _c(
                "v-container",
                { staticClass: "DashboardBox", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-breadcrumbs", {
                            staticClass: "ml-n7 mt-n5",
                            attrs: { items: _vm.breadcrumbItems, large: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "v-breadcrumbs-item",
                                      {
                                        class: !item.disabled ? "cursor" : "",
                                        attrs: {
                                          href: item.href,
                                          disabled: item.disabled
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changeWindow(1)
                                          }
                                        }
                                      },
                                      [
                                        !item.disabled
                                          ? _c(
                                              "v-icon",
                                              { attrs: { size: "35px" } },
                                              [_vm._v("mdi-chevron-left")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" " + _vm._s(item.text) + " ")
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "borderbox d-flex justify-space-between elevation-1 pa-3 align-center"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c("img", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      src: require("@/assets/IconCM.svg"),
                                      width: "35px",
                                      height: "35px"
                                    }
                                  }),
                                  _c(
                                    "p",
                                    { staticClass: "textpCustom title" },
                                    [_c("b", [_vm._v("Detalle de Cliente")])]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "ma-0pa-0" },
                            [
                              !_vm.loadingCustomerInfo
                                ? _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "d-flex justify-left ml-5",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c("h1", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.customerSelected.name
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "d-flex flex-row mt-n4 ml-10",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "font-weight-regular mt-1"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.customerSelected.rif
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass:
                                                    "userStatusChip ml-3 ma-2",
                                                  staticStyle: {
                                                    "font-size": "125%"
                                                  },
                                                  attrs: {
                                                    color: _vm.customerSelected
                                                      .adminUser
                                                      ? "green"
                                                      : "gray",
                                                    dark: "",
                                                    label: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.customerSelected
                                                        .adminUser
                                                        ? "Administrador Activo"
                                                        : "Sin Administrador"
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("v-skeleton-loader", {
                                                staticClass: "mt-n3",
                                                attrs: {
                                                  type: "list-item-two-line"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "ma-0 pa-0 reversed" },
                [
                  _c("ContactDirectory", {
                    attrs: {
                      customer: _vm.customer,
                      customerManagement: true,
                      adminUser: true
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: 15000, color: _vm.snackbarColor },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: { click: _vm.closeSnackbar }
            },
            [_vm._v(" Cerrar ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }